import React from 'react';
import './AboutUs.css'; // You can extract and paste your CSS here
import Seo from "../components/Seo";





const AboutUs = () => {
  return (

    
    <>
     <Seo
        title="About Mortbuzz - Trusted Loan Experts in Pune"
        description="Learn more about Mortbuzz, your trusted loan experts in Pune. We specialize in home loans, LAP, personal loans, car loans, and business loans with the best interest rates."
        keywords="about Mortbuzz, loan experts in Pune, home loan consultant Pune, LAP services Pune, personal loan advisor, best loan agency in Pune"
        canonical="https://www.mortbuzz.in/about-us"
      />
      






      {/* Hero Section */}
  <section className="hero-about d-flex align-items-center">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6" data-aos="fade-right">
           <h1 className="display-3 fw-bold mb-4">
           <span className="floating-element text-white">🏡</span><br />
           Your Trusted Partner in<br />
           <span className="text-warning">Home Loans</span>
           </h1>
           <p className="lead">Simplifying the complex world of home financing since 2015</p>
      </div>
      <div className="col-lg-6" data-aos="fade-left">
        <img src="/images/Bank Pages/about-us-image.png" className="img-fluid rounded-3 shadow-lg" alt="Mortbuzz Home Loan Team" />
      </div>
    </div>
  </div>
</section>


      {/* Who We Are */}
      <section className="py-5 bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center mb-5" data-aos="fade-up">
              <h2 className="display-5 fw-bold mb-4 text-white">Who We Are</h2>
              <p className="lead text-white">
                Mortbuzz Solutions is a leading financial advisory firm based in Pune, specializing in home loans, loan against property, balance transfers, and personal loans.
              </p>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-md-6" data-aos="fade-right">
              <div className="p-4 bg-dark-100 rounded-3 shadow-sm h-100 text-white border border-primary">
                <p className='text-white'>
                  With a deep understanding of the real estate and banking sectors, we bridge the gap between borrowers and lenders, ensuring you get the best terms, lowest rates, and a hassle-free experience.
                </p>
              </div>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              <div className="p-4 bg-dark rounded-3 shadow-sm h-100 text-white border border-primary">
                <p className='text-white'>
                  Our team of certified financial experts has helped over 10,000 customers secure loans totaling 200+ crores, making us one of the most trusted names in Pune's financial landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-5">
        <div className="container">
          <div className="row g-4">
            {[
              { value: '6,000+', label: 'Happy Customers' },
              { value: '8000+',  label: 'Loans Sanctioned' },
              { value: '30+',    label: 'Banking Partners' },
              { value: '10+',    label: 'Years of Experience' },
            ].map((stat, index) => (
              <div className="col-md-3" data-aos="fade-up" data-aos-delay={100 * (index + 1)} key={index}>
                <div className="stat-card text-center p-4 bg-dark text-white border border-primary">
                  <div className="stat-number animate__animated animate__pulse animate__infinite animate__slower">{stat.value}</div>
                  <h5>{stat.label}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-5 bg-dark-50 text-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center mb-5" data-aos="fade-up">
              <h2 className="display-5 fw-bold mb-4">Our Core Services</h2>
              <p className="lead">Comprehensive financial solutions tailored to your needs</p>
            </div>
          </div>

          <section className="mortbuzz-universe-style bg-dark border border-primary">
            <div className="loan-card-container">
              {[
                { img: '/images/Bank pages/home-ser.png', title: 'Home Loan' },
                { img: '/images/Bank pages/red_loan.png', title: 'Loan Against Property' },
                { img: '/images/Bank pages/personal_loan_service.png', title: 'Personal Loan' },
                { img: '/images/Bank pages/document_loan.png', title: 'Business Loan' },
                { img: '/images/Bank pages/car_loan_service.png', title: 'Car Loan' },
                { img: '/images/Bank pages/education_loan_service.png', title: 'Education Loan' },
              ].map((service, index) => (
                <div className="card-loan-mortbuzz" key={index}>
                  <img src={service.img} alt={service.title} />
                  <h3>{service.title}</h3>
                </div>
              ))}
            </div>
          </section>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-right">
              <h2 className="display-5 fw-bold mb-4 text-white">Our Story</h2>
              <p className='text-white'>Founded in 2015, Mortbuzz Solutions began with a simple goal: to make loan processes transparent and stress-free in a market cluttered with complexities.</p>
              <p className='text-white'>Over the years, we've grown into a team of passionate advisors who thrive on seeing our clients succeed.</p>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="timelinemort">
                {[
                  { year: '2015', desc: 'Founded with a vision to simplify home loans' },
                  { year: '2018', desc: 'Expanded services to loan against property' },
                  { year: '2020', desc: 'Reached 1000+ happy customers milestone' },
                  { year: '2023', desc: 'Crossed ₹200 crores in loan disbursements' },
                ].map((item, index) => (
                  <div className="timeline-itemmort" key={index}>
                    <h4>{item.year}</h4>
                    <p>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-5 bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center mb-5" data-aos="fade-up">
              <h2 className="display-5 fw-bold mb-4">Meet the Team</h2>
              <p className="lead">Experienced financial advisors committed to your success</p>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            {[
              { name: 'Kishan Rathod', role: 'CEO' },
              { name: 'Manisha Rathod', role: 'CTO' },
            ].map((member, index) => (
              <div className="col-md-3" data-aos="zoom-in" key={index}>
                <div className="team-card card bg-dark text-white border border-primary">
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" className="card-img-top" alt="Team member" />
                  <div className="card-body text-center">
                    <h5 className="card-title text-primary">{member.name}</h5>
                    <p className="text-white">{member.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      

      {/* Full Team Grid */}
      <section className="team-section">
        <h2 className="section-title">Our Leadership Team</h2>
        {[
          ['Priya/CEO', 'Rahul/CTO'],
          ['Neha/HR', 'Amit/Finance', 'Divya/Marketing'],
          ['Karan/Legal', 'Meera/Design', 'Ravi/Sales', 'Simran/Support'],
          ['Ajay/Dev', 'Sneha/QA', 'Manish/Ops', 'Tanvi/Intern'],
          ['Anil/Field', 'Shreya/Outreach'],
          ['Final/Support'],
        ].map((group, levelIdx) => (
          <div className={`team-level level-${levelIdx + 1}`} key={levelIdx}>
            {group.map((entry, i) => {
              const [name, role] = entry.split('/');
              return (
                <div className="member-card" key={i}>
                  <img src={`https://i.pravatar.cc/100?img=${levelIdx * 5 + i + 1}`} alt={name} />
                  <h4>{name}</h4>
                  <p>{role}</p>
                </div>
              );
            })}
          </div>
        ))}
      </section>





         <section className="py-5 bg-primary text-white">
           <div className="container text-center" data-aos="zoom-in">
              <h2 className="display-5 fw-bold mb-4">Let's Build Your Future Together</h2>
              <p className="lead mb-5">
             Whether you're a first-time homebuyer or looking to refinance, we're here to guide you.
              </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
               <a href="tel:18002104422" className="btn btn-light btn-lg px-5 mb-2">
               <i className="bi bi-telephone"></i> 1800 210 4422
               </a>
               <a href="mailto:contact@mortbuzz.in" className="btn btn-outline-light btn-lg px-5 mb-2">
               <i className="bi bi-envelope"></i> Email Us
               </a>
             </div>
            </div>
       </section>

    </>
  );
};

export default AboutUs;
